/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import ExampleLoading from 'react-scale/components/website/index/Products/examples/exampleLoading';

const TaskResponseAnnotation = dynamic(
  () => import('react-scale/components/website/index/Products/examples/tasks/annotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

const response = {
  annotations: [
    {
      width: 60,
      height: 30,
      left: 89,
      top: 68,
      label: 'box'
    },
    {
      width: 57,
      height: 26,
      left: 150,
      top: 72,
      label: 'box'
    },
    {
      width: 70,
      height: 51,
      left: 16,
      top: 95,
      label: 'box'
    },
    {
      width: 63,
      height: 47,
      left: 88,
      top: 97,
      label: 'box'
    },
    {
      width: 63,
      height: 46,
      left: 148,
      top: 99,
      label: 'box'
    },
    {
      width: 75,
      height: 49,
      left: 220,
      top: 98,
      label: 'box'
    },
    {
      width: 66,
      height: 46,
      left: 273,
      top: 77,
      label: 'box'
    },
    {
      width: 63,
      height: 38,
      left: 332,
      top: 77,
      label: 'box'
    },
    {
      width: 70,
      height: 50,
      left: 393,
      top: 69,
      label: 'box'
    },
    {
      width: 75,
      height: 49,
      left: 462,
      top: 67,
      label: 'box'
    },
    {
      width: 77,
      height: 48,
      left: 418,
      top: 97,
      label: 'box'
    },
    {
      width: 70,
      height: 43,
      left: 487,
      top: 114,
      label: 'box'
    },
    {
      width: 68,
      height: 49,
      left: 622,
      top: 112,
      label: 'box'
    },
    {
      width: 65,
      height: 46,
      left: 688,
      top: 114,
      label: 'box'
    },
    {
      width: 62,
      height: 46,
      left: 752,
      top: 115,
      label: 'box'
    },
    {
      width: 57,
      height: 40,
      left: 706,
      top: 67,
      label: 'box'
    },
    {
      width: 55,
      height: 37,
      left: 762,
      top: 69,
      label: 'box'
    },
    {
      width: 57,
      height: 39,
      left: 831,
      top: 76,
      label: 'box'
    },
    {
      width: 56,
      height: 36,
      left: 892,
      top: 79,
      label: 'box'
    },
    {
      width: 55,
      height: 35,
      left: 951,
      top: 78,
      label: 'box'
    },
    {
      width: 63,
      height: 42,
      left: 828,
      top: 116,
      label: 'box'
    },
    {
      width: 63,
      height: 45,
      left: 892,
      top: 114,
      label: 'box'
    },
    {
      width: 60,
      height: 50,
      left: 957,
      top: 114,
      label: 'box'
    },
    {
      width: 47,
      height: 39,
      left: 1027,
      top: 76,
      label: 'box'
    },
    {
      width: 65,
      height: 36,
      left: 1027,
      top: 116,
      label: 'box'
    },
    {
      width: 75,
      height: 57,
      left: 1143,
      top: 103,
      label: 'box'
    },
    {
      width: 70,
      height: 49,
      left: 1227,
      top: 30,
      label: 'box'
    },
    {
      width: 61,
      height: 47,
      left: 1298,
      top: 32,
      label: 'box'
    },
    {
      width: 60,
      height: 46,
      left: 1361,
      top: 31,
      label: 'box'
    },
    {
      width: 76,
      height: 46,
      left: 1424,
      top: 33,
      label: 'box'
    },
    {
      width: 61,
      height: 48,
      left: 1500,
      top: 30,
      label: 'box'
    },
    {
      width: 62,
      height: 52,
      left: 1561,
      top: 29,
      label: 'box'
    },
    {
      width: 70,
      height: 45,
      left: 1631,
      top: 34,
      label: 'box'
    },
    {
      width: 82,
      height: 43,
      left: 1744,
      top: 37,
      label: 'box'
    },
    {
      width: 85,
      height: 53,
      left: 1270,
      top: 113,
      label: 'box'
    },
    {
      width: 67,
      height: 49,
      left: 1356,
      top: 116,
      label: 'box'
    },
    {
      width: 66,
      height: 49,
      left: 1431,
      top: 115,
      label: 'box'
    },
    {
      width: 59,
      height: 47,
      left: 1498,
      top: 106,
      label: 'box'
    },
    {
      width: 60,
      height: 40,
      left: 1562,
      top: 116,
      label: 'box'
    },
    {
      width: 62,
      height: 42,
      left: 1634,
      top: 114,
      label: 'box'
    },
    {
      width: 61,
      height: 48,
      left: 1701,
      top: 105,
      label: 'box'
    },
    {
      width: 68,
      height: 44,
      left: 1760,
      top: 200,
      label: 'box'
    },
    {
      width: 62,
      height: 43,
      left: 1701,
      top: 200,
      label: 'box'
    },
    {
      width: 59,
      height: 41,
      left: 1642,
      top: 200,
      label: 'box'
    },
    {
      width: 72,
      height: 47,
      left: 1550,
      top: 189,
      label: 'box'
    },
    {
      width: 60,
      height: 42,
      left: 1494,
      top: 200,
      label: 'box'
    },
    {
      width: 62,
      height: 42,
      left: 1432,
      top: 201,
      label: 'box'
    },
    {
      width: 65,
      height: 42,
      left: 1292,
      top: 198,
      label: 'box'
    },
    {
      width: 65,
      height: 41,
      left: 1226,
      top: 196,
      label: 'box'
    },
    {
      width: 62,
      height: 44,
      left: 1025,
      top: 195,
      label: 'box'
    },
    {
      width: 61,
      height: 43,
      left: 953,
      top: 197,
      label: 'box'
    },
    {
      width: 65,
      height: 44,
      left: 888,
      top: 196,
      label: 'box'
    },
    {
      width: 63,
      height: 38,
      left: 825,
      top: 199,
      label: 'box'
    },
    {
      width: 65,
      height: 52,
      left: 748,
      top: 186,
      label: 'box'
    },
    {
      width: 63,
      height: 42,
      left: 685,
      top: 194,
      label: 'box'
    },
    {
      width: 61,
      height: 43,
      left: 625,
      top: 194,
      label: 'box'
    },
    {
      width: 64,
      height: 39,
      left: 549,
      top: 201,
      label: 'box'
    },
    {
      width: 59,
      height: 41,
      left: 489,
      top: 199,
      label: 'box'
    },
    {
      width: 68,
      height: 43,
      left: 422,
      top: 198,
      label: 'box'
    },
    {
      width: 63,
      height: 39,
      left: 344,
      top: 197,
      label: 'box'
    },
    {
      width: 67,
      height: 42,
      left: 279,
      top: 197,
      label: 'box'
    },
    {
      width: 64,
      height: 39,
      left: 217,
      top: 198,
      label: 'box'
    },
    {
      width: 62,
      height: 40,
      left: 145,
      top: 199,
      label: 'box'
    },
    {
      width: 72,
      height: 45,
      left: 74,
      top: 194,
      label: 'box'
    },
    {
      width: 66,
      height: 43,
      left: 13,
      top: 196,
      label: 'box'
    },
    {
      width: 78,
      height: 41,
      left: 17,
      top: 274,
      label: 'box'
    },
    {
      width: 72,
      height: 43,
      left: 81,
      top: 281,
      label: 'box'
    },
    {
      width: 91,
      height: 48,
      left: 143,
      top: 282,
      label: 'box'
    },
    {
      width: 75,
      height: 39,
      left: 331,
      top: 313,
      label: 'box'
    },
    {
      width: 68,
      height: 50,
      left: 420,
      top: 279,
      label: 'box'
    },
    {
      width: 65,
      height: 44,
      left: 487,
      top: 282,
      label: 'box'
    },
    {
      width: 62,
      height: 43,
      left: 549,
      top: 268,
      label: 'box'
    },
    {
      width: 64,
      height: 41,
      left: 624,
      top: 283,
      label: 'box'
    },
    {
      width: 72,
      height: 51,
      left: 685,
      top: 280,
      label: 'box'
    },
    {
      width: 62,
      height: 44,
      left: 825,
      top: 280,
      label: 'box'
    },
    {
      width: 63,
      height: 42,
      left: 889,
      top: 280,
      label: 'box'
    },
    {
      width: 61,
      height: 43,
      left: 953,
      top: 281,
      label: 'box'
    },
    {
      width: 62,
      height: 42,
      left: 1028,
      top: 274,
      label: 'box'
    },
    {
      width: 64,
      height: 44,
      left: 1229,
      top: 283,
      label: 'box'
    },
    {
      width: 82,
      height: 50,
      left: 1340,
      top: 282,
      label: 'box'
    },
    {
      width: 67,
      height: 45,
      left: 1431,
      top: 284,
      label: 'box'
    },
    {
      width: 66,
      height: 41,
      left: 1494,
      top: 276,
      label: 'box'
    },
    {
      width: 64,
      height: 39,
      left: 1559,
      top: 285,
      label: 'box'
    },
    {
      width: 62,
      height: 40,
      left: 1637,
      top: 283,
      label: 'box'
    },
    {
      width: 62,
      height: 42,
      left: 1698,
      top: 284,
      label: 'box'
    },
    {
      width: 66,
      height: 44,
      left: 1761,
      top: 368,
      label: 'box'
    },
    {
      width: 62,
      height: 41,
      left: 1700,
      top: 367,
      label: 'box'
    },
    {
      width: 68,
      height: 41,
      left: 1635,
      top: 367,
      label: 'box'
    },
    {
      width: 61,
      height: 42,
      left: 1498,
      top: 368,
      label: 'box'
    },
    {
      width: 70,
      height: 40,
      left: 1430,
      top: 369,
      label: 'box'
    },
    {
      width: 65,
      height: 40,
      left: 1091,
      top: 368,
      label: 'box'
    },
    {
      width: 62,
      height: 40,
      left: 1029,
      top: 368,
      label: 'box'
    },
    {
      width: 59,
      height: 59,
      left: 952,
      top: 350,
      label: 'box'
    },
    {
      width: 60,
      height: 44,
      left: 891,
      top: 366,
      label: 'box'
    },
    {
      width: 62,
      height: 44,
      left: 829,
      top: 365,
      label: 'box'
    },
    {
      width: 71,
      height: 43,
      left: 685,
      top: 366,
      label: 'box'
    },
    {
      width: 61,
      height: 41,
      left: 624,
      top: 367,
      label: 'box'
    },
    {
      width: 65,
      height: 45,
      left: 548,
      top: 364,
      label: 'box'
    },
    {
      width: 61,
      height: 42,
      left: 488,
      top: 366,
      label: 'box'
    },
    {
      width: 69,
      height: 61,
      left: 424,
      top: 349,
      label: 'box'
    },
    {
      width: 90,
      height: 49,
      left: 282,
      top: 366,
      label: 'box'
    },
    {
      width: 69,
      height: 44,
      left: 215,
      top: 365,
      label: 'box'
    },
    {
      width: 68,
      height: 42,
      left: 140,
      top: 356,
      label: 'box'
    },
    {
      width: 105,
      height: 49,
      left: 11,
      top: 365,
      label: 'box'
    },
    {
      width: 60,
      height: 38,
      left: 85,
      top: 466,
      label: 'box'
    },
    {
      width: 73,
      height: 47,
      left: 215,
      top: 450,
      label: 'box'
    },
    {
      width: 91,
      height: 44,
      left: 287,
      top: 450,
      label: 'box'
    },
    {
      width: 68,
      height: 40,
      left: 422,
      top: 453,
      label: 'box'
    },
    {
      width: 68,
      height: 42,
      left: 485,
      top: 451,
      label: 'box'
    },
    {
      width: 62,
      height: 45,
      left: 549,
      top: 448,
      label: 'box'
    },
    {
      width: 64,
      height: 43,
      left: 623,
      top: 451,
      label: 'box'
    },
    {
      width: 78,
      height: 45,
      left: 687,
      top: 451,
      label: 'box'
    },
    {
      width: 55,
      height: 24,
      left: 848,
      top: 460,
      label: 'box'
    },
    {
      width: 55,
      height: 29,
      left: 938,
      top: 458,
      label: 'box'
    },
    {
      width: 65,
      height: 45,
      left: 1090,
      top: 450,
      label: 'box'
    },
    {
      width: 30,
      height: 38,
      left: 1186,
      top: 453,
      label: 'box'
    },
    {
      width: 28,
      height: 43,
      left: 1155,
      top: 452,
      label: 'box'
    },
    {
      width: 62,
      height: 42,
      left: 1232,
      top: 452,
      label: 'box'
    },
    {
      width: 61,
      height: 41,
      left: 1291,
      top: 453,
      label: 'box'
    },
    {
      width: 67,
      height: 41,
      left: 1352,
      top: 454,
      label: 'box'
    },
    {
      width: 80,
      height: 44,
      left: 1545,
      top: 451,
      label: 'box'
    },
    {
      width: 61,
      height: 43,
      left: 1634,
      top: 449,
      label: 'box'
    },
    {
      width: 74,
      height: 41,
      left: 1754,
      top: 538,
      label: 'box'
    },
    {
      width: 77,
      height: 43,
      left: 1680,
      top: 536,
      label: 'box'
    },
    {
      width: 83,
      height: 44,
      left: 1536,
      top: 525,
      label: 'box'
    },
    {
      width: 76,
      height: 39,
      left: 1271,
      top: 534,
      label: 'box'
    },
    {
      width: 63,
      height: 31,
      left: 1226,
      top: 545,
      label: 'box'
    },
    {
      width: 64,
      height: 42,
      left: 1087,
      top: 534,
      label: 'box'
    },
    {
      width: 62,
      height: 44,
      left: 1026,
      top: 535,
      label: 'box'
    },
    {
      width: 68,
      height: 43,
      left: 748,
      top: 534,
      label: 'box'
    },
    {
      width: 51,
      height: 31,
      left: 691,
      top: 533,
      label: 'box'
    },
    {
      width: 68,
      height: 44,
      left: 620,
      top: 534,
      label: 'box'
    },
    {
      width: 81,
      height: 43,
      left: 481,
      top: 536,
      label: 'box'
    },
    {
      width: 95,
      height: 42,
      left: 418,
      top: 534,
      label: 'box'
    },
    {
      width: 63,
      height: 40,
      left: 347,
      top: 537,
      label: 'box'
    },
    {
      width: 83,
      height: 41,
      left: 218,
      top: 533,
      label: 'box'
    },
    {
      width: 100,
      height: 42,
      left: 82,
      top: 526,
      label: 'box'
    },
    {
      width: 79,
      height: 41,
      left: 14,
      top: 536,
      label: 'box'
    },
    {
      width: 43,
      height: 16,
      left: 15,
      top: 611,
      label: 'box'
    },
    {
      width: 33,
      height: 16,
      left: 46,
      top: 626,
      label: 'box'
    },
    {
      width: 34,
      height: 16,
      left: 14,
      top: 626,
      label: 'box'
    },
    {
      width: 31,
      height: 17,
      left: 15,
      top: 642,
      label: 'box'
    },
    {
      width: 55,
      height: 38,
      left: 142,
      top: 612,
      label: 'box'
    },
    {
      width: 40,
      height: 18,
      left: 217,
      top: 625,
      label: 'box'
    },
    {
      width: 42,
      height: 19,
      left: 249,
      top: 640,
      label: 'box'
    },
    {
      width: 31,
      height: 16,
      left: 219,
      top: 643,
      label: 'box'
    },
    {
      width: 36,
      height: 16,
      left: 270,
      top: 612,
      label: 'box'
    },
    {
      width: 34,
      height: 16,
      left: 225,
      top: 611,
      label: 'box'
    },
    {
      width: 35,
      height: 14,
      left: 426,
      top: 614,
      label: 'box'
    },
    {
      width: 32,
      height: 17,
      left: 417,
      top: 628,
      label: 'box'
    },
    {
      width: 32,
      height: 15,
      left: 448,
      top: 629,
      label: 'box'
    },
    {
      width: 31,
      height: 16,
      left: 480,
      top: 643,
      label: 'box'
    },
    {
      width: 35,
      height: 16,
      left: 510,
      top: 642,
      label: 'box'
    },
    {
      width: 36,
      height: 16,
      left: 484,
      top: 611,
      label: 'box'
    },
    {
      width: 41,
      height: 17,
      left: 479,
      top: 626,
      label: 'box'
    },
    {
      width: 32,
      height: 18,
      left: 519,
      top: 625,
      label: 'box'
    },
    {
      width: 31,
      height: 18,
      left: 438,
      top: 709,
      label: 'box'
    },
    {
      width: 32,
      height: 18,
      left: 467,
      top: 709,
      label: 'box'
    },
    {
      width: 32,
      height: 19,
      left: 428,
      top: 726,
      label: 'box'
    },
    {
      width: 31,
      height: 18,
      left: 456,
      top: 726,
      label: 'box'
    },
    {
      width: 38,
      height: 18,
      left: 351,
      top: 712,
      label: 'box'
    },
    {
      width: 31,
      height: 17,
      left: 352,
      top: 728,
      label: 'box'
    },
    {
      width: 39,
      height: 20,
      left: 306,
      top: 725,
      label: 'box'
    },
    {
      width: 33,
      height: 20,
      left: 225,
      top: 724,
      label: 'box'
    },
    {
      width: 42,
      height: 15,
      left: 15,
      top: 717,
      label: 'box'
    },
    {
      width: 30,
      height: 14,
      left: 62,
      top: 703,
      label: 'box'
    },
    {
      width: 30,
      height: 16,
      left: 56,
      top: 715,
      label: 'box'
    },
    {
      width: 33,
      height: 15,
      left: 31,
      top: 702,
      label: 'box'
    },
    {
      width: 36,
      height: 20,
      left: 623,
      top: 724,
      label: 'box'
    },
    {
      width: 34,
      height: 16,
      left: 685,
      top: 712,
      label: 'box'
    },
    {
      width: 36,
      height: 16,
      left: 748,
      top: 705,
      label: 'box'
    },
    {
      width: 31,
      height: 15,
      left: 756,
      top: 692,
      label: 'box'
    },
    {
      width: 30,
      height: 16,
      left: 778,
      top: 731,
      label: 'box'
    },
    {
      width: 35,
      height: 15,
      left: 748,
      top: 731,
      label: 'box'
    },
    {
      width: 81,
      height: 45,
      left: 1268,
      top: 702,
      label: 'box'
    },
    {
      width: 69,
      height: 43,
      left: 1348,
      top: 704,
      label: 'box'
    },
    {
      width: 84,
      height: 29,
      left: 1434,
      top: 693,
      label: 'box'
    },
    {
      width: 86,
      height: 28,
      left: 1432,
      top: 722,
      label: 'box'
    },
    {
      width: 103,
      height: 27,
      left: 1520,
      top: 721,
      label: 'box'
    },
    {
      width: 100,
      height: 28,
      left: 1523,
      top: 692,
      label: 'box'
    },
    {
      width: 88,
      height: 52,
      left: 1633,
      top: 696,
      label: 'box'
    },
    {
      width: 98,
      height: 27,
      left: 1723,
      top: 723,
      label: 'box'
    },
    {
      width: 100,
      height: 23,
      left: 1722,
      top: 699,
      label: 'box'
    },
    {
      width: 93,
      height: 42,
      left: 1668,
      top: 622,
      label: 'box'
    },
    {
      width: 63,
      height: 24,
      left: 1758,
      top: 626,
      label: 'box'
    },
    {
      width: 70,
      height: 46,
      left: 1026,
      top: 614,
      label: 'box'
    },
    {
      width: 72,
      height: 52,
      left: 1146,
      top: 614,
      label: 'box'
    }
  ]
};

export default () => (
  <TaskResponseAnnotation
    hover
    imageURL="/static/img/website/solutions/robotics/slider/slide-1.jpg"
    annotations={response.annotations}
    bgTransparent
    responsive
    rounded
  />
);
